/* eslint-disable */
import axios from 'axios'

const dashboard = {
    namespaced:true,
        state: {
            aniversary:[],
            aniversaryAll:[],
            absents:[],
            birthdayAll:[],
            birthday:[],
            employeeLeave:[],
            leaveCredits:[],
            leaveRefresh:[],
        },
        getters: {},
        actions: {
            GET_LEAVE_REFRESH: async ({commit}) => {
                let { data } = await axios.get(`api/leaveRefresh`)
                commit('SET_LEAVE_REFRESH', data)
            },
    
            GET_ANNIVERSARRY_ALL: async ({commit}) => {
                let { data } = await axios.get(`api/anniversary/all`)
                commit('SET_ANNIVERSARRY_ALL', data)
            },
    
            GET_ANNIVERSARRY: async ({commit}) => {
                let { data } = await axios.get(`api/anniversary`)
                commit('SET_ANNIVERSARRY', data)
            },
    
            GET_ABSENTS: async ({commit}) => {
                let { data } = await axios.get(`api/countAbsent`)
                commit('SET_ABSENTS', data)
            },
    
            GET_EMPLOYEE_BIRTHDAY: async ({commit}) => {
                let { data } = await axios.get(`api/celebrant`)
                commit('SET_EMPLOYEE_BIRTHDAY', data)
            },

            GET_BIRTHDAY: async ({commit}) => {
                let { data } = await axios.get(`api/birthday`)
                commit('SET_BIRTHDAY', data)
            },
    
            GET_EMPLOYEE_LEAVE: async ({commit}) => {
                let { data } = await axios.get(`api/employee/leave`)
                commit('SET_EMPLOYEE_LEAVE', data)
            },

            GET_LEAVE_CREDITS: async ({commit}) => {
                let { data } = await axios.get(`api/credits`)
                commit('SET_LEAVE_CREDITS', data)
            },  
        },
        mutations: {   
            SET_LEAVE_REFRESH: (state, payload) => {
                state.leaveRefresh = payload
            },

            SET_ANNIVERSARRY_ALL: (state, payload) => {
                state.aniversaryAll = payload
            },
    
            SET_ANNIVERSARRY: (state, payload) => {
                state.aniversary = payload
            },
    
            SET_ABSENTS: (state, payload) => {
                state.absents = payload
            },
    
            SET_EMPLOYEE_BIRTHDAY: (state, payload) => {
                state.birthdayAll = payload
            },

            SET_BIRTHDAY: (state, payload) => {
                state.birthday = payload
            },
    
            SET_EMPLOYEE_LEAVE: (state, payload) => {
                state.employeeLeave = payload
            },

            SET_LEAVE_CREDITS: (state, payload) => {
                state.leaveCredits = payload
            },
        }
}

export default dashboard


// WEBPACK FOOTER //
// ./src/modules/userDashboard.js